<div *ngIf="documents && documents.length > 0; else noDocumentsTemplate">
    <div class="d-flex justify-content-center align-items-center pt-4">
        <h5>
            Stampare i seguenti documenti
        </h5>
    </div>
    <div class="d-flex justify-content-center align-items-center" >
        <table aria-label="documents-table" class="table mt-3">
            <thead class="bg-light">
                <tr>
                    <th scope="col">Documenti da stampare</th>
                    <th scope="col">Download</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let document of documents">
                    <tr *ngIf="document?.providedFromCompany">
                        <td>
                            <h6>{{ document.descrizioneDocumento }}</h6>
                        </td>
                        <td class="fixed-width">
                            <ng-container *ngIf="!document?.isDownloading; else downloadingTemplate">
                              <mat-icon class="download-icon" aria-hidden="false" aria fontIcon="download" (click)="retrieveDocumentInfo(document)"></mat-icon>
                            </ng-container>
                            <ng-template #downloadingTemplate>
                                <div class="spinner-border spinner-border-sm custom-spinner" role="status"></div>
                            </ng-template>
                        </td>
                        <td class="fixed-width">
                            <span class="badge" 
                                  [ngClass]="{
                                    'badge-green': document?.isDownloaded, 
                                    'badge-red': !document?.isDownloaded && !document?.isDownloading, 
                                    'badge-yellow': document?.isDownloading
                                  }">
                                {{ document?.isDownloaded ? 'Scaricato' : document?.isDownloading ? 'Download in corso' : 'Da scaricare' }}
                            </span>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
<ng-template #noDocumentsTemplate>
    <div *ngIf="errorRetrievingDocs; else noDocsToDownload">
        <div class="mt-4 d-flex text-center flex-column align-items-center">
            <mat-icon class="no-results-icon">file_copy_off</mat-icon>
            <h4 class="no-docs-text">Errore nel recupero dei documenti</h4>
            <div class="mt-2" *ngIf="showRetrieveDocsButton">
                <button mat-raised-button color="primary" (click)="downloadDocRetry()">Scarica documenti</button>
            </div>
        </div>
    </div>
    <ng-template #noDocsToDownload>
        <div class="mt-4 d-flex text-center flex-column align-items-center">
            <ng-container *ngIf="!isAnnulloAppendice || isISVPolicy; else templateDocAnnulloAppendice">
                <mat-icon class="no-results-icon">file_copy_off</mat-icon>
                <h4 class="no-docs-text">Non ci sono documenti da scaricare</h4>
            </ng-container>
            <ng-template #templateDocAnnulloAppendice>
                <mat-icon class="no-results-icon">check_circle</mat-icon>
                <h4 class="no-docs-text">Operazione effettuata con successo</h4>
                <h5 class="no-docs-text">L'operazione di Annullo Appendice non prevede documenti da scaricare</h5>
            </ng-template>
        </div>
    </ng-template>
</ng-template>